// Copyright (c) Docugami, Inc. All rights reserved.

import { ReportViewMode } from 'hooks/navigationService';
import { dgIconNames } from 'hooks/dgIcons';
import { WorkPathType } from 'networking/WorkPathApi';
import { ReportDefinition } from 'networking/reportsApi';

export function isSingleDocumentReportView(viewMode: ReportViewMode): boolean {
    return viewMode === ReportViewMode.Document || viewMode === ReportViewMode.Abstract;
}

export const getIconForReportViewMode = (mode: ReportViewMode) => {
    switch (mode) {
        case ReportViewMode.Document:
            return dgIconNames.DgPageNoWriting;
        case ReportViewMode.Table:
            return dgIconNames.DgTableLayout;
        case ReportViewMode.Abstract:
            return dgIconNames.DgAbstractPages;
        case ReportViewMode.Chat:
            return dgIconNames.DgChat;
    }
}

export const getNameForReportViewMode = (mode: ReportViewMode) => {
    switch (mode) {
        case ReportViewMode.Document:
            return "Document View";
        case ReportViewMode.Table:
            return "Grid View";
        case ReportViewMode.Abstract:
            return "Abstract Preview";
        case ReportViewMode.Chat:
            return "Chat";
    }
}

export function getDefaultViewModeForReport(report: ReportDefinition, workPathType: WorkPathType): ReportViewMode {
    const isPublished = report.isPublished;
    const reportHasEntries = report.entries.length > 0;

    if (isPublished) {
        return ReportViewMode.Table;
    }
    else if (reportHasEntries) {
        return workPathType === WorkPathType.Abstract ? ReportViewMode.Abstract : ReportViewMode.Table
    }

    return ReportViewMode.Document;
}
